/**
 * The site footer — copyright and the legal links.
 *
 * Modelled on DragDuro's footer ("DragDuro · © TheDigicar LLC · …"). It carries
 * the two legal documents and the class calculator — everything svcdue.com
 * serves without an account.
 *
 * The links use plain <Link>s and the pages render outside the auth guard, so
 * the footer works the same signed in, signed out, and on a public garage.
 */

import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="footer">
      <span>
        SvcDue · ©{' '}
        {COPYRIGHT_YEAR}{' '}
        <a href="https://www.thedigicar.com/" target="_blank" rel="noreferrer noopener">
          TheDigicar LLC
        </a>{' '}
        ·{' '}
        <b className="c-amber">Know what's due before you load the trailer.</b>
      </span>
      <span className="footer-links">
        {/* The class calculator needs no account, so it belongs in the one strip
            that renders signed in, signed out, and on a public garage link. */}
        <Link to="/tools/classcalc">Class calculator</Link>
        <span aria-hidden>·</span>
        <Link to="/terms">Terms</Link>
        <span aria-hidden>·</span>
        <Link to="/privacy">Privacy</Link>
      </span>
    </footer>
  );
}

/**
 * Fixed, not `new Date().getFullYear()`.
 *
 * A copyright year that silently ticks over on New Year's Day is a footer that
 * changes without a deploy — harmless, but it means the rendered site no longer
 * matches what was shipped, which is a small lie in a legal notice. Bump it on
 * purpose.
 */
const COPYRIGHT_YEAR = 2026;
